import http from "../requestBase";

const API_BASE = "api/Clients";

/**
 * Get all Clients
 */
function getClients() {
  return http.get(API_BASE);
}

/**
 * Get 1 Client by id
 * @param {number} id
 */
function getClientbyID(id) {
  var queryString = `${API_BASE}/${id}`;
  return http.get(queryString);
}

/**
 * create a new Client
 * @param {JSON} content - the new Client
 */
function createClient(content) {
  var queryString = `${API_BASE}`;
  return http.post(queryString, content);
}

/**
 * Update 1 Client
 * @param {number} id The id of the Client
 * @param {JSON} content The updated ClientData
 */
function updateClient(id, content) {
  var queryString = `${API_BASE}/${id}`;
  return http.put(queryString, content);
}

export default {
  getClientbyID,
  getClients,
  updateClient,
  createClient,
};



// WEBPACK FOOTER //
// ./src/services/Clients/index.js